import { authAsyncStore, AuthAsyncStore } from "./models/authAsync";
import { authStateStore , AuthStateStore } from "./models/authState";
import { authSyncStore, AuthSyncStore } from "./models/authSync";



class AuthStore {
  state: AuthStateStore;
  sync: AuthSyncStore;
  async: AuthAsyncStore;

  constructor(
    authState: AuthStateStore,
    authSync: AuthSyncStore,
    authAsync: AuthAsyncStore,
  ) {
    this.state = authState;
    this.sync = authSync;
    this.async = authAsync;
  }
}

export const authStore = new AuthStore(
  authStateStore,
  authSyncStore,
  authAsyncStore,
);
